import axiosClient from "./axiosClient";
import { unwrapApiResponse } from "../utils/apiResponse";

export const getPages = async (page = 1, pageSize = 50) => {
  const response = await axiosClient.get("/api/admin/pages", {
    params: { page, pageSize },
  });
  return unwrapApiResponse(response);
};

export const getPageById = async (id) => {
  const response = await axiosClient.get(`/api/admin/pages/${id}`);
  return unwrapApiResponse(response);
};

export const createPage = async (payload) => {
  const response = await axiosClient.post("/api/admin/pages", payload);
  return unwrapApiResponse(response);
};

export const updatePage = async (id, payload) => {
  const response = await axiosClient.put(`/api/admin/pages/${id}`, payload);
  return unwrapApiResponse(response);
};

export const deletePage = async (id) => {
  const response = await axiosClient.delete(`/api/admin/pages/${id}`);
  return unwrapApiResponse(response);
};
